import React, { PropsWithChildren } from 'react';
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';

import { theme } from '../theme';

/**
 * Provide the theme to the app
 */
const ThemeContainer: React.FC<PropsWithChildren> = (props) => {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {props.children}
    </MuiThemeProvider>
  );
};

export { ThemeContainer };
